// extracted by mini-css-extract-plugin
export default {"subtitle":"index_subtitle__fPGOJ","label":"index_label__249Kh","icon":"index_icon__4J6lK"};